/* eslint-disable arrow-body-style */
import { ColoredSelectOption } from '@src/common/types';
import { GraphNode } from '../types';
import { laIdTypeColorAssignment } from '../laIdTypeColorAssignment';

export function getLegend(nodes: GraphNode[]): ColoredSelectOption[] {
  const typesSet = new Set<string>();
  nodes.forEach((node) => {
    typesSet.add(node.type);
  });

  const types = Array.from(typesSet);

  return types
    .map((type) => laIdTypeColorAssignment.getItem(type))
    .sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));
}
